import { useMemo } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Condition, Iteration } from 'Component/others';
import { TextBold, TextRegular } from 'UiKit/typography';
import { LocationIcon } from 'Asset/icon';

import styles from './styles.module.css';
import BadgeInactiveHost from '../badge-inactive-host';

const Card = ({ info, onCardClick }) => {
  const { t } = useTranslation('schedule');
  const extendedProps = info?.event?.extendedProps;

  return (
    <Box className={styles['card__container']} id={`card__${info?.title}`} onClick={onCardClick}>
      <Box className={styles['indicator']} />
      <Box className={styles['card__content--container']}>
        <Flex gap={'4px'} flexDirection={'column'}>
          <Flex gap={'4px'} alignItems={'end'}>
            <TextBold className={styles['card__schedule-count--text']}>{extendedProps?.scheduleCount}</TextBold>
            <TextBold className={styles['card__schedule-count--text-desc']}>{t('scheduleText')}</TextBold>
          </Flex>
          <TextRegular className={styles['time__text']}>{info?.timeText}</TextRegular>
        </Flex>
        <Box className={styles['card__area--container']}>
          <LocationIcon size="12px" color="var(--color-primary60)" />
          <Iteration
            items={extendedProps?.areas}
            render={(item) => {
              return (
                <Box key={item} className={styles['card__badge-area--box']} bgColor={item?.color || '#ECD3FF'}>
                  <TextRegular className={styles['card__badge-area--text']}>{item?.name || '-'}</TextRegular>
                </Box>
              );
            }}
          />
        </Box>
      </Box>
      <Condition statement={extendedProps?.noActiveHostScheduleCount}>
        <Box className={styles['card__box--inactive-host']}>
          <BadgeInactiveHost count={extendedProps?.noActiveHostScheduleCount} />
        </Box>
      </Condition>
    </Box>
  );
};

const MemoizedCard = ({ ...props }) => useMemo(() => <Card {...props} /> /* eslint-disable */, [props?.info]);

export default MemoizedCard;
